export class PasswordProtectedError extends Error {}

export class TooManyRequestsError extends Error {
  constructor(
    message = 'Too many requests. Please slow down and try again later.'
  ) {
    super(message);
    this.name = 'TooManyRequestsError';
  }
}

export class AtomNotDeletableError extends Error {}

export class RowDeletionError extends Error {
  private numberOfUndeletedRows: number;

  constructor(numberOfUndeletedRows: number) {
    super(`${numberOfUndeletedRows} row(s) not deleted. Please try again.`);
    this.numberOfUndeletedRows = numberOfUndeletedRows;
  }

  get undeletedRows(): number {
    return this.numberOfUndeletedRows;
  }
}
